import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { createContainer, type Container } from '@infrastructure/di/container';

const ContainerContext = createContext<Container | null>(null);

export function ContainerProvider({
  children,
  container,
}: {
  children: ReactNode;
  container?: Container;
}): JSX.Element {
  const value = useMemo(
    () =>
      container ??
      createContainer({
        onUnauthenticated: () => window.dispatchEvent(new CustomEvent('bbm:unauthenticated')),
      }),
    [container],
  );
  return <ContainerContext.Provider value={value}>{children}</ContainerContext.Provider>;
}

/** Seul point d'accès de la vue à la couche applicative. */
export function useContainer(): Container {
  const container = useContext(ContainerContext);
  if (!container) {
    throw new Error('useContainer doit être utilisé dans un <ContainerProvider>.');
  }
  return container;
}
